<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12 md3 class="text-xs-center" px-1 mt-2>
        <v-flex class="date__picker">
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="date"
                label="Date"
                prepend-icon="event"
                readonly
                v-on="on"
              />
            </template>
            <v-date-picker v-model="date" @input="menu = false"/>
          </v-menu>
        </v-flex>
      </v-flex>
    </v-layout>
    <v-data-table
      :headers="tableHeaders"
      :items="items"
      :loading="loadingInProgress"
      :no-data-text="loadingItemsText"
      :rows-per-page-items="rowsPerPageItems"
      :pagination.sync="pagination"
      :hide-actions="true"
      class="elevation-1"
    >
      <template slot="items" slot-scope="props">
        <td class="slotTime" :class="props.item.timeline">{{ props.item.time }}</td>
        <td :class="props.item.timeline">{{ props.item.start_time }}</td>
        <td :class="props.item.timeline">{{ props.item.end_time }}</td>
        <td :class="props.item.timeline">{{ props.item.type }}</td>
        <td :class="props.item.timeline">{{ props.item.case_manager }}</td>
        <td :class="props.item.timeline">{{ getCaseCrew(props.item) }}</td>
        <td :class="props.item.timeline">{{ props.item.id }}</td>
      </template>
    </v-data-table>
    <AddScheduledCaseButton />
    <AddCaseNameAndDateDialog v-model="dialogModel" :date="dateForNewLead" @input="loadSchedules" v-if="dateForNewLead"/>
  </div>
</template>

<script>
  // import resourcesMixins from '@/mixins/Resources'
  import schedulesAPI from '@/api/resources/schedules'

  import AddScheduledCaseButton from '@/components/buttons/AddScheduledCaseButton'
  import AddCaseNameAndDateDialog from '@/components/dialogs/AddCaseNameAndDateDialog'

  import { mapGetters } from 'vuex'
  import _ from 'lodash'

  export default {
    name: 'Cases',
    components: { AddScheduledCaseButton, AddCaseNameAndDateDialog },
    // mixins: [ resourcesMixins ],
    data () {
      return {
        resources: 'cases',
        items: [],
        vendorItemsPromise: null,
        tableHeaders: [
          { text: '', value: 'time' },
          { text: 'Start Time', value: 'start_time' },
          { text: 'End Time', value: 'end_time' },
          { text: 'Type', value: 'type' },
          { text: 'Case manager', value: 'users_id' },
          { text: 'Crew', value: 'crew' },
          { text: 'Case ID', value: 'id' }
        ],
        caseID: 0,
        currentUserServiceId: 0,
        clientName: '',
        dialogOpen: false,
        dialogMessage: '',
        vendorInventories: [],
        disabled: {
          sendQuotationMailToClientBtn: false
        },
        vendorServices: [],
        rowsPerPageItems: [-1],
        pagination: {
          descending: true,
          rowsPerPage: -1,
          sortBy: 'created_at'
        },
        date: this.moment().format('YYYY-MM-DD'),
        menu: false,
        dateForNewLead: this.moment().format('YYYY-MM-DD'),
        dialogModel: false,
        services: []
      }
    },
    watch: {
      date () {
        this.loadCases()
      }
    },
    computed: {
      ...mapGetters({
        servicesList: 'allServices'
      })
    },
    provide: function () {
      return {
        onClickDate: this.onClickDate
      }
    },
    methods: {
      formatTime (date) {
        return date ? this.moment(date, 'YYYY-MM-DD HH:mm:ss').format('HH:mm') : '-'
      },
      getCaseType (item) {
        switch (item.status) {
          case 'pending':
            return 'Pickup'
          case 'approved':
            return 'Setup'
          case 'filled':
            return 'Wake'
          default:
            return 'Wake'
        }
      },
      getCaseCrew (item) {
        let closing = 1
        if (item.status === 'pending' || item.status === 'approved') closing = 0
        return this.services.filter(i => i.cases_id === item.id && i.is_closing === closing).map(i => i.service.name).join(', ')
      },
      async loadServices () {
        let services = []
        const apiUrl = this.$store.getters.config.api_host
        for (let i = 0; i < this.items.length; i++) {
          if (this.items[i].id) {
            const response = await this.$axios.get(`${apiUrl}/api/cases/${this.items[i].id}/lead`)
            if (response) {
              response.data.additional_data.filter(filtering => filtering.service.description.toLowerCase().replace(/\s/g, '').replace(/-/g, '') !== 'casemanager').map(i => services.push(i))
            }
          }
        }
        this.services = services
      },
      loadCases () {
        const apiUrl = this.$store.getters.config.api_host
        this.$axios.get(`${apiUrl}/api/cases/all?date=${this.date}`).then(response => {
          const data = this.prepareData(response.data.additional_data)
          this.items = this.formTable(data)
          this.loadServices()
        })
      },
      getTimelinePosition (time) {
        const diff = this.moment().diff(time, 'minutes')
        if (diff >= 0 && diff < 60) return 'current'
        if (diff < 0) return 'future'
        if (diff > 60) return 'past'
      },
      prepareData (data) {
        return data.map(i => {
          const timeline = this.getTimelinePosition(this.moment(i.wake_start, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm'))
          return i.wake_start && i.wake_end ? {
            time: '',
            timeline: timeline,
            id: i.id,
            date: this.moment(i.wake_start, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'),
            start_time: this.moment(i.wake_start, 'YYYY-MM-DD HH:mm:ss').format('HH:mm'),
            end_time: this.moment(i.wake_end, 'YYYY-MM-DD HH:mm:ss').format('HH:mm'),
            type: this.getCaseType(i),
            case_manager: i.manager_name,
            services: i.services
          } : null
        }).filter(i => i && this.moment(i.date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') === this.date)
      },
      formTable (data) {
        const times = [...Array(24).keys()]
        const newData = []
        for (let k = 0; k < times.length; k++) {
          const time = times[k]
          const nextTime = time < 9 ? `0${time + 1}00` : time < 23 ? `${time + 1}00` : `0`
          const currentTime = time < 10 ? `0${time}00` : `${time}00`
          const timeItems = []
          for (let i = 0; i < data.length; i++) {
            const itemTime = data[i].start_time.replace(':', '')
            if (itemTime < nextTime && itemTime >= currentTime) timeItems.push(data[i])
          }
          if (timeItems.length === 0) {
            const timeline = this.getTimelinePosition(this.date + ' ' + currentTime.slice(0, -2) + ':00')
            timeItems.push({
              time: currentTime.slice(0, -2) + ':00',
              timeline: timeline,
              id: null,
              date: null,
              start_time: null,
              end_time: null,
              type: null,
              case_manager: null,
              services: null
            })
          } else {
            timeItems.sort((a, b) => {
              const timeA = parseInt(a.start_time.replace(':', ''))
              const timeB = parseInt(b.start_time.replace(':', ''))
              let comparison = 0
              if (timeA > timeB) {
                comparison = 1
              } else if (timeA < timeB) {
                comparison = -1
              }
              return comparison
            })
            timeItems[0].time = currentTime.slice(0, -2) + ':00'
          }
          newData[k] = timeItems
        }
        return newData.flat()
      },
      loadSchedules () {
        schedulesAPI.loadSchedules().then(result => {
          this.eventsRaw = JSON.parse(JSON.stringify(result))
          this.events = this.normalizeForScheduleComponent(result)
        }, () => {})
      },
      onClickDate (date) {
        if (this.$can('use', 'appointment-schedule-create-new-case')) {
          this.dateForNewLead = this.moment(date).subtract(1, 'month').format('YYYY-MM-DD')
          this.dialogModel = true
        }
      },
      normalizeForScheduleComponent: function (data) {
        let localData = JSON.parse(JSON.stringify(data))
        localData.forEach((item, i) => {
          let caseDataLabel = item.case && '\n\nCase #: ' + item.case.id + '\nCase Name: ' + item.case.name

          item.date = this.moment(item.schedule_start, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')
          item.time = this.moment(item.schedule_start, 'YYYY-MM-DD HH:mm:ss').format('HH:mm')
          item.endDate = this.moment(item.schedule_end, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')
          item.endDateTime = this.moment(item.schedule_end, 'YYYY-MM-DD HH:mm:ss').format('HH:mm')

          item.duration = this.moment
            .duration(this.moment(item.schedule_end, 'YYYY-MM-DD hh:mm:ss')
              .diff(this.moment(item.schedule_start, 'YYYY-MM-DD hh:mm:ss')))
            .asMinutes() || 60

          item.open = false

          item.title = 'Staff: \n'

          item.classes = item.case && this.selectEventColor(item.case.status)

          item.case_manager = null
          if (item.leads_id) {
            let filtered = this.eventsRaw.filter(filtering => filtering.leads_id === item.leads_id)

            item.title += filtered.map(mapping => mapping.service !== null ? mapping.service.description + ' ' + mapping.service.name : '') + '; ' + caseDataLabel

            let managerService = _.find(filtered, ['service.description', 'Case Manager'])
            if (managerService && managerService.service.users_id) {
              item.case_manager = managerService.service.users_id
            }

            let itemsWithSameLead = localData.filter(filtering => filtering.leads_id === item.leads_id && filtering.item_id !== item.item_id).map(mapping => mapping.item_id)

            if (itemsWithSameLead.length > 0) {
              itemsWithSameLead.forEach(sameItem => {
                let index = localData.findIndex(finding => finding.item_id === sameItem && finding.leads_id === item.leads_id)

                localData.splice(index, 1)
              })
            }
          } else {
            item.title += item.service.description + ' ' + item.service.name + ';' + caseDataLabel
          }
        })

        return localData
      }
    },
    mounted () {
      // this.loadListing()
      this.loadCases()
    },
    props: {
      detailCaseButtonActionIsDefault: {
        type: Boolean,
        default: false,
        required: false
      },
      detailCaseButtonActionIsGoToCheckListsTab: {
        type: Boolean,
        default: false,
        required: false
      },
      detailCaseButtonActionIsGoToInvoicesTab: {
        type: Boolean,
        default: false,
        required: false
      },
      crewSelecting: {
        type: Boolean,
        default: false,
        required: false
      }
    }
  }
</script>

<style scoped>
.slotTime {
  font-weight: bold;
  color: rgba(119, 119, 119, 0.7);
}
td.past {
  background: #eee;
}
td.current {
  background: rgba(173, 216, 230, 0.4);
}
</style>



// WEBPACK FOOTER //
// ViewCasesTable.vue?33401652